import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import InputBase from 'components/InputBase';

const StyledInput = styled.input`
  outline: none;
  width: 100%;
  border: 0;
  border-bottom: ${({ error, theme }) => (error ? theme.palette.input.error : theme.palette.input.text)} solid 2px;
  border-radius: 0;
  margin-top: ${({ theme }) => theme.spacing}px ;
  padding-bottom: ${({ theme }) => theme.spacing}px ;
  font-size: 1.5rem;

  &:focus {
    border-bottom-color: ${({ theme }) => theme.palette.input.focus};
  }

  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: ${({ theme }) => theme.palette.grey[3]};
  }
  ::-moz-placeholder { /* Firefox 19+ */
    color: ${({ theme }) => theme.palette.grey[3]};
  }
  :-ms-input-placeholder { /* IE 10+ */
    color: ${({ theme }) => theme.palette.grey[3]};
  }
  :-moz-placeholder { /* Firefox 18- */
    color: ${({ theme }) => theme.palette.grey[3]};
  }

  /* IE11 */
  &::-ms-reveal {
    display: none;
  }

`;

const PasswordToggleButton = styled.button.attrs(() => ({ type: 'button' }))`
  margin: 0;
  padding: 0;
  background: none;
  border: none;
`;

const Input = ({
  name, label, placeholder, value, onChange, error, disabled, type, className, focus, ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef(null);
  const classes = ['Input'];

  useEffect(() => {
    if (focus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [focus, inputRef]);

  if (className) {
    classes.push(className);
  }
  return (
    <InputBase label={label} className={classes.join(' ')} error={error} {...rest}>
      <StyledInput
        type={type === 'password' && showPassword ? 'text' : type}
        placeholder={placeholder}
        onChange={onChange}
        name={name}
        value={value}
        disabled={disabled}
        error={error}
        ref={inputRef}
      />
      {type === 'password' && (
        <PasswordToggleButton
          onClick={() => setShowPassword(!showPassword)}
        >
          <FontAwesomeIcon
            icon={showPassword ? faEyeSlash : faEye}
          />
        </PasswordToggleButton>
      )}
    </InputBase>
  );
};

Input.displayName = 'Input';

Input.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['text', 'password', 'email']),
  className: PropTypes.string,
  focus: PropTypes.bool,
};

Input.defaultProps = {
  placeholder: '',
  name: null,
  value: undefined,
  onChange: null,
  error: null,
  disabled: false,
  type: 'text',
  className: null,
  focus: false,
};

export default Input;
